var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4486 3.87476C13.8011 3.52237 13.9992 3.0444 13.9992 2.54599C13.9993 2.04758 13.8014 1.56956 13.449 1.21709C13.0966 0.864619 12.6186 0.666566 12.1202 0.666504C11.6218 0.666441 11.1438 0.864374 10.7913 1.21676L1.89397 10.1161C1.73918 10.2704 1.62471 10.4604 1.56064 10.6694L0.679972 13.5708C0.662742 13.6284 0.661441 13.6897 0.676206 13.748C0.690971 13.8063 0.721252 13.8596 0.763836 13.9021C0.80642 13.9446 0.859719 13.9748 0.918078 13.9895C0.976436 14.0041 1.03768 14.0027 1.09531 13.9854L3.99731 13.1054C4.20609 13.0419 4.39609 12.9282 4.55064 12.7741L13.4486 3.87476Z",
    stroke: "#4A5565",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cc95a02fcd07208ba0c5957889fae2d2.svg";
export { ForwardRef as ReactComponent };